import React from 'react';
import { FormContainer } from 'components/FormContainer';
import { RegistryProductFile } from 'types/types';
import { UploadForm } from './UploadForm';

type UploadFormModalProps = {
  defaultValues?: RegistryProductFile;
  onClose: () => void;
  onSubmit: (data: RegistryProductFile, selectedFile: File) => void;
  title: string;
  saving: boolean;
};

export const UploadFormModal = ({
  defaultValues,
  onClose,
  onSubmit,
  title,
  saving,
}: UploadFormModalProps) => (
  <FormContainer
    onSubmit={({ selectedFile, ...data }) =>
      onSubmit(data as RegistryProductFile, selectedFile?.[0] as File)
    }
    formConfig={{ defaultValues: { ...defaultValues } }}
  >
    <UploadForm title={title} onClose={onClose} saving={saving} />
  </FormContainer>
);
